import { render, staticRenderFns } from "./CompetitionSummary.vue?vue&type=template&id=5de3e236&scoped=true"
import script from "./CompetitionSummary.vue?vue&type=script&lang=js"
export * from "./CompetitionSummary.vue?vue&type=script&lang=js"
import style0 from "./CompetitionSummary.vue?vue&type=style&index=0&id=5de3e236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3e236",
  null
  
)

export default component.exports